import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CargueSegurosComponent } from './components/cargue-presupuesto/cargue-presupuesto.component';


const routes: Routes = [
    {
      path: "carguePresupuesto",
      component: CargueSegurosComponent,
      data: {
        title: 'Cargue Masivo Archivos'
      },
      
    }
  ];
  
  @NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class CargueRoutingModule { }